var _defs, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustratieIKnow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 217.90602 174.38465",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #66c3ec;\n      }\n\n      .cls-3 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-4 {\n        fill: #bbd773;\n      }\n\n      .cls-5 {\n        isolation: isolate;\n        opacity: 0.15;\n      }\n\n      .cls-6 {\n        fill: #e3e3e3;\n      }\n\n      .cls-7 {\n        fill: #7d7d7d;\n      }\n\n      .cls-8 {\n        fill: #b33e32;\n      }\n\n      .cls-9 {\n        fill: #eb5241;\n      }\n\n      .cls-10 {\n        fill: #e0c1a4;\n      }\n\n      .cls-11 {\n        fill: #454545;\n      }\n\n      .cls-12 {\n        fill: #757575;\n      }\n\n      .cls-13 {\n        fill: #987f51;\n      }\n\n      .cls-14 {\n        fill: #79c48e;\n      }\n\n      .cls-15 {\n        fill: #dde3e9;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.56892,108.12561a49.54017,49.54017,0,0,0,63.36547,29.88721l.00053-.00024A49.54009,49.54009,0,0,0,104.8221,74.6471l-.00019-.00049A49.54015,49.54015,0,0,0,41.45647,44.7594l-.00055.00025a49.52125,49.52125,0,0,0-29.887,63.366Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M77.88994,148.24451a2.00014,2.00014,0,0,1-1.882-1.325L36.76894,37.62464a2.00015,2.00015,0,0,1,1.20681-2.55811h.00019a1.99993,1.99993,0,0,1,2.558,1.206L79.773,145.56751a2.00017,2.00017,0,0,1-1.20682,2.5581H78.566A1.97046,1.97046,0,0,1,77.88994,148.24451Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    className: "cls-2",
    d: "M11.56892,108.12561a49.54017,49.54017,0,0,0,63.36547,29.88721l.00053-.00024A49.54009,49.54009,0,0,0,104.8221,74.6471l-.00019-.00049A49.54015,49.54015,0,0,0,41.45647,44.7594l-.00055.00025a49.52125,49.52125,0,0,0-29.887,63.366Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1527",
    "data-name": "Rectangle 1527",
    className: "cls-4",
    d: "M27.99307,67.90278,6.05177,75.78392A5.73,5.73,0,0,1-1.278,72.3286h0a5.73,5.73,0,0,1,3.456-7.32948L24.11925,57.118A5.73,5.73,0,0,1,31.449,60.5733h0A5.73,5.73,0,0,1,27.99307,67.90278Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    className: "cls-4",
    d: "M-29.93706,114.44763a13.6,13.6,0,0,1,8.674-16.34594l46.972-16.864a13.61307,13.61307,0,0,1,17.217,7.332,13.366,13.366,0,0,1-7.22629,17.46656q-.299.12414-.6037.2334l-11.224,4.029a1.66394,1.66394,0,0,0-1,2.12793h0a1.66309,1.66309,0,0,0,2.127,1l4.5-1.615a6.989,6.989,0,0,1,8.94021,4.21484l.0008.0022h0a6.99,6.99,0,0,1-4.21564,8.9414l-.00137.00049L-7.435,139.92566a6.99,6.99,0,0,1-8.94144-4.21558l-.00055-.00146h0a6.992,6.992,0,0,1,4.218-8.94189l-1.138-3.167a13.353,13.353,0,0,1-16.59781-9.00659Q-29.91636,114.52063-29.93706,114.44763Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1528",
    "data-name": "Rectangle 1528",
    className: "cls-4",
    x: 55.98204,
    y: 116.72037,
    width: 26.49236,
    height: 10.78752,
    rx: 5.39326,
    transform: "translate(-37.20475 30.59129) rotate(-19.7579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    className: "cls-4",
    d: "M62.54994,74.78357l13.164-4.727a2.622,2.622,0,0,0,1.733-3.02588,2.52288,2.52288,0,0,0-3.3-1.771l-5.581,2A6.14207,6.14207,0,0,1,60.71,63.55383l-.0001-.00024h0a6.14209,6.14209,0,0,1,3.70423-7.85669l.00078-.00024,36.092-12.957a2.52311,2.52311,0,0,1,3.227,1.522l2.446,6.813a2.523,2.523,0,0,1-1.522,3.227l-5.611,2.01391a2.621,2.621,0,0,0-1.732,3.02588,2.52305,2.52305,0,0,0,3.05322,1.84644,2.55585,2.55585,0,0,0,.24678-.07446l5.746-2.063A2.52112,2.52112,0,0,1,109.58612,60.57l.00084.00244,2.446,6.813a2.515,2.515,0,0,1-.331,2.33008l1.973,5.5,4.148-1.49a5.55214,5.55214,0,0,1,6.916,2.686,5.39985,5.39985,0,0,1-2.57216,7.19043q-.235.11133-.47985.19946l-36.443,13.084a5.552,5.552,0,0,1-6.915-2.686,5.39984,5.39984,0,0,1,2.57216-7.19043q.235-.11133.47984-.19946l11.621-4.1731a2.7,2.7,0,0,0,1.628-3.45092h0a2.7,2.7,0,0,0-3.451-1.627l-24.236,8.7a6.313,6.313,0,0,1-8.032-3.44189A6.141,6.141,0,0,1,62.37111,74.851Q62.46,74.81581,62.54994,74.78357Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M58.24994,149.40174A58.0137,58.0137,0,0,1,38.593,36.7865l1.351,3.76392A54.0132,54.0132,0,1,0,76.44993,142.22156l1.352,3.76392A57.75421,57.75421,0,0,1,58.24994,149.40174Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M39.37092,167.17371c8.1,0,16.5-12.448,16.5-19.06592h5.137c0,6.61792,8.4,19.06592,16.5,19.06592s8.1,7.21094,8.1,7.21094h-54.338S31.26994,167.17371,39.37092,167.17371Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    className: "cls-5",
    d: "M104.81993,74.64368a49.518,49.518,0,0,0-45.5-32.79,49.54093,49.54093,0,0,1,10.84584,95.80444l-.01585.00562a49.36,49.36,0,0,1-17.87,2.90991A49.5384,49.5384,0,0,0,104.82039,74.6449Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    className: "cls-6",
    d: "M97.97993,41.8617l-3.879-2.583-3.879-2.584-.623-.415-24.241,45.16309a.547.547,0,0,0,.907.6001l32.338-39.769Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    className: "cls-7",
    d: "M98.60394,42.27771l-32.338,39.77a.549.549,0,0,1-.909-.605h0L97.418,41.48767Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    className: "cls-8",
    d: "M124.67093,21.62952A22.14292,22.14292,0,0,1,107.311,47.692l-.00207.00049A22.1441,22.1441,0,0,1,98.60657,4.2677l.00137-.00024a22.14516,22.14516,0,0,1,26.063,17.36206Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    className: "cls-9",
    d: "M122.43294,19.85462a22.14236,22.14236,0,0,1-34.339,22.53906A22.14526,22.14526,0,0,1,98.60657,4.26892l.00137-.00024a22.06808,22.06808,0,0,1,16.979,3.523A22.042,22.042,0,0,1,122.43294,19.85462Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    className: "cls-10",
    d: "M110.41594,22.37854a2.216,2.216,0,0,0,1.467-2.76806c-.573-3.2-2.4-6,.495-8.749.356-.33789,1.412-.53393,1.864.731,1.125,3.1499,3.311,7.83789,4.227,8.636,1.25,1.08691.728,1.5,14.292,6.85888l-4.581,4.80493c-10.509-6.033-11.025-6.60791-11.85-7.2229-1.858-1.38794-5.491-.448-7.392-.137a2.30961,2.30961,0,0,1-.03-.53809C108.96693,23.07166,109.68994,22.74768,110.41594,22.37854Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Leg",
    className: "cls-11",
    d: "M163.90294,75.14466l-11.672,91.76611h8.01l10.985-38.937,15.054-52.8291Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Leg-2",
    className: "cls-12",
    d: "M163.84993,75.14466c7.369,26.05,8.836,44.554,8.836,44.554s1.927,17.7,10.234,47.21191h8.3c-1-5.51489-1.8-10.71606-2.431-15.5a174.3149,174.3149,0,0,1-.195-44.956,226.56618,226.56618,0,0,0,1.708-31.3Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Shoe",
    d: "M187.81293,174.38367v-.83008l-5.4.8291h-15.779v-1.65893s9.992-2.7,16.195-7.05909h8.719l.416,8.719Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Shoe-2",
    d: "M157.21294,174.38367v-.83008l-5.4.8291h-15.779v-1.65893s9.992-2.7,16.2-7.05909h8.719l.416,8.719Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Head-2",
    className: "cls-10",
    d: "M163.85594,31.12952l1.688-11.93994c-2.689,1.62011-5.33,2.3999-6.571,2.083-3.109-.8-3.394-12.176-.989-16.66088s14.776-6.43995,15.4,2.446a11.25106,11.25106,0,0,1-2.992,8.082l3.431,15.991Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    className: "cls-13",
    d: "M165.04994,8.03967a8.07436,8.07436,0,0,0-2.767-2.831c-4.381.06909-4.893-.71606-4.893-3.363a15.42484,15.42484,0,0,1,6-1.60009,7.23705,7.23705,0,0,1,4.744.35009,6.15194,6.15194,0,0,1,4.462,4.1001c2.718,4.69312.655,9.57788-2.127,11.24609-.74-.877-1.385-1.72705-1.962-2.541a2.492,2.492,0,0,0-1.74005-4.27393h-.00095a2.46369,2.46369,0,0,0-.3.01807C166.13394,9.24768,165.50093,8.7367,165.04994,8.03967Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    className: "cls-10",
    d: "M204.08093,67.94251l7.174,16.51a39.091,39.091,0,0,1,6.526,8.38891c.252.80591.325,2.179-1.81.7s-4.447-2.929-5.2-2.34594.07,2.282-1.154,2.947q-1.223.66613-2.885-8.58911l-9.415-12.37891Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Coat_Back",
    "data-name": "Coat Back",
    className: "cls-14",
    d: "M141.86594,38.27454c-7.59-.53906-11.67-1.32593-23.725-10.94409l5.037-5.2a62.42241,62.42241,0,0,0,13.351,4.38794,30.76322,30.76322,0,0,0,11.137.384c5.085-.751,11.322-1.73194,19.114-2.95508l3.379,5.97412C163.12793,40.53772,147.31894,38.66858,141.86594,38.27454Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Shirt",
    className: "cls-15",
    d: "M172.08993,21.58362l-9.164,1.437c0,17.37793-3.518,36.47412-5.939,48.68189-.21,1.0581-.484,3.154.968,3.154l25.3-1.57691C181.76294,53.13953,179.66994,33.77063,172.08993,21.58362Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Coat_Front",
    "data-name": "Coat Front",
    className: "cls-14",
    d: "M203.28893,81.78967q-6.618-7.7091-16.333-25.23291a104.38232,104.38232,0,0,1,3.891,21.08106h-28.6c-5.536-13.991,6.8-56.05689,6.8-56.05689h3.631c20.555,12.667,24.451,27.74,37.267,58.89991Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustratieIKnow);
export default __webpack_public_path__ + "static/media/illustratie_i_know.34d9196a1c41347f85f761fa6d46dee0.svg";
export { ForwardRef as ReactComponent };